import { useAllowedEmpresas } from './useAllowedEmpresas'

/**
 * ¿Ve el usuario el módulo de reports?
 *
 * Los reports de cliente son de la empresa avp, así que los ve quien tenga
 * acceso a ella. Tener 'avp' entre las empresas equivale exactamente a tener el
 * App Role Empresa.AVP o Empresa.All, por el mapeo de core/permissions.py — de
 * modo que no hace falta ampliar /auth/me ni añadir un claim nuevo.
 *
 * Esto solo controla lo que se pinta. El cierre de verdad está en el backend
 * (get_reports_empresas), que devuelve 403 a quien no tenga acceso.
 */
export function useHasReportsAccess(): boolean {
  return useAllowedEmpresas().includes('avp')
}
